import { Component } from '@angular/core';
import { path_module_employee, path_module_public } from '@app/models/routes.name';
import { HelpService } from '@app/services/help.service';
import { UserService } from '@app/services/user.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-job-application-login-modal',
  templateUrl: './job-application-login-modal.component.html',
  styleUrls: ['./job-application-login-modal.component.css']
})
export class JobApplicationLoginModalComponent {

  public idJob: Number = 0;
  public jobPosition: string = "";
  public jobTitle: string = "";
  public jobGradeFrom: string = "";
  public jobGradeTo: string = "";
  public isCallEmployerPage: boolean = false;
  private modalName = 'modal-login-user';
  constructor(public helpService: HelpService, private userService: UserService) { }

  setValues(id: Number, position: string, jobTitle: string, gradeFrom: string, gradeTo: string, isCallEmployerPage: boolean) {
    this.idJob = id;
    this.jobPosition = position;
    this.jobTitle = jobTitle;
    this.jobGradeFrom = gradeFrom;
    this.jobGradeTo = gradeTo;
    this.isCallEmployerPage = isCallEmployerPage;
    this.helpService.modalShow(this.modalName);
  }

  onClickRegisterButton(event) {
    event.preventDefault();
    this.userService.logOut(false);

    if (!(environment.production === true && this.isCallEmployerPage)) {
      this.helpService.navigateToRegisterAdvice(this.idJob)
      return;
    }

    window.open(`${environment.basePath}/${path_module_employee.module}/${path_module_employee.form_basic}?returnUrl=%2F${path_module_public.advice}%2F${this.idJob}`, '_blank');
  }

  onClickLoginButton(event) {
    event.preventDefault();
    this.userService.logOut(false);

    if (!(environment.production === true && this.isCallEmployerPage)) {
      this.helpService.navigateToLoginAdvice(this.idJob);
      return;
    }
    window.open(`${environment.basePath}/${path_module_employee.module}/${path_module_employee.login}?returnUrl=%2F${path_module_public.advice}%2F${this.idJob}`, '_blank');
  }
}
